// QES Vendor Selection (Vollmacht tab)
export const QES_VENDOR_SELECTION = {
  SECTION_TITLE: "Signaturanbieter auswählen",
  SECTION_DESCRIPTION:
    "Wählen Sie einen Anbieter (QES), über den die Vollmacht digital unterschrieben werden soll.",
  START_SIGNING: "Signatur starten",
  SELECT_VENDOR_PROMPT: "Bitte wählen Sie Ihren QES-Anbieter",
};

export const availableVendors = [
  {
    key: "YOUTRUST",
    displayName: "YouTrust",
    logoText: "YouTrust",
    brandColor: "color2",
    description:
      "Führender europäischer Anbieter für einfache, DSGVO-konforme elektronische Signaturen im Webbrowser.",
    active: true,
  },
  {
    key: "NECT_IDENT",
    displayName: "Nect Ident",
    logoText: "nect",
    brandColor: "color23",
    description:
      "Schnelle und hochsichere Video-Identifizierung per künstlicher Intelligenz in wenigen Sekunden.",
    active: true,
  },
  {
    key: "VERIMI_ID_PASS",
    displayName: "Verimi ID-Pass",
    logoText: "Verimi",
    brandColor: "verimiColor",
    description:
      "Sichere Identitätsprüfung über Ihr bestehendes Verimi-Konto mit direkter Anbindung an den Personalausweis.",
    active: true,
  },
];

export const signingProviderConstants = {
  PROVIDERS_REQUEST: "SIGNING_PROVIDERS_REQUEST",
  PROVIDERS_SUCCESS: "SIGNING_PROVIDERS_SUCCESS",
  PROVIDERS_FAILURE: "SIGNING_PROVIDERS_FAILURE",
  REPRESENTATIVES_REQUEST: "SIGNING_REPRESENTATIVES_REQUEST",
  REPRESENTATIVES_SUCCESS: "SIGNING_REPRESENTATIVES_SUCCESS",
  REPRESENTATIVES_FAILURE: "SIGNING_REPRESENTATIVES_FAILURE",
  SELECT_PROVIDER: "SIGNING_PROVIDER_SELECT",
  SIGNING_CASE_REQUEST: "SIGNING_CASE_REQUEST",
  SIGNING_CASE_SUCCESS: "SIGNING_CASE_SUCCESS",
  SIGNING_CASE_FAILURE: "SIGNING_CASE_FAILURE",
  SIGNING_CASE_CANCEL_SUCCESS: "SIGNING_CASE_CANCEL_SUCCESS",
  SIGNING_FLOW_RESET: "SIGNING_FLOW_RESET",
};

export const SIGNING_PROVIDER = {
  VERIMI: "VERIMI",
  YOUTRUST: "YOUTRUST" || "YOUSIGN",
  NECT: "NECT",
};

export const SIGNING_CASE_STATUS = {
  CREATED: "CREATED",
  PENDING_VERIFICATION: "PENDING_VERIFICATION",
  AWAITING_SIGNER_SELECTION: "AWAITING_SIGNER_SELECTION",
  PROCESSING: "PROCESSING",
  RECEIVED: "RECEIVED",
  FAILED: "FAILED",
};

export const JP_SIGNING_CONSTANTS = {
  SELECT_SIGNERS: "Unterzeichner auswählen",
  // SELECT_SIGNERS_HELP:
  //   "Wählen Sie eine oder mehrere vertretungsberechtigte Personen aus und hinterlegen Sie für jede Person eine E-Mail-Adresse.",
  REPRESENTATIVE: "Vertretungsberechtigte Person",
  NON_REPRESENTATIVE: "Nicht vertretungsberechtigte Person",
  FIRST_NAME: "Vorname",
  LAST_NAME: "Nachname",
  BIRTH_DATE: "Geburtsdatum",
  // POA_PROVIDER: "PoA-Anbieter auswählen",
  UPLOAD_POA: "POA-Dokument hochladen",
  // POA_HINT: "PDF, PNG or JPG bis zu 10 MB",
  CANCEL: "Abbrechen",
  CONFIRM: "Bestätigen",
  MISSING_SIGNER_EMAIL:
    "Bitte geben Sie für jede Person eine gültige E-Mail-Adresse ein.",
  MISSING_SIGNER:
    "Bitte wählen Sie mindestens eine unterzeichnende Person aus.",
  MISSING_POA:
    "Bitte laden Sie die Vollmacht hoch und wählen Sie einen PoA-Anbieter aus.",
};

export const QES_SIGNING_START = {
  SELECTED_VENDOR_TITLE: "Ausgewählter Anbieter",
  SELECTED_VENDOR_SUBTITLE:
    "Der Signaturprozess wird mit diesem Anbieter fortgesetzt.",
  CANCEL_BUTTON: "Abbrechen",
  DELETE_POA_BUTTON: "Vollmacht Löschen",
  // COMPANY_NAME_LABEL: "Unternehmen",
  HRA_HRB: "HRA/HRB",
  PERMANENT_POA: "Dauervollmacht",
  SEPA_MANDATE: "SEPA-Mandat",
  START_VERIFICATION: "Unternehmensverifizierung starten....",
  // SELECT_COMPANY_TITLE: "Wählen Sie das Unternehmen aus",
  BACK_BUTTON: "Zurück",
  NEXT_BUTTON: "Weiter",
  SELECT_SIGNERS_INSTRUCTION:
    "Erforderliche Unterzeichner auswählen: Jede ausgewählte Person muss sich identifizieren und digital signieren. Wir konnten folgende Personen aus dem Handelsregister extrahieren:",
  SELECT_ALL: "Alle auswählen",
  EMAIL_LABEL: "E-Mail Adresse",
  EMAIL_PLACEHOLDER: "E-Mail eingeben",
  EMAIL_REQUIRED: "E-Mail ist erforderlich",
  ON_BEHALF_OF: "Im Auftrag von",
  PERSON_NOT_FOUND_TITLE: "Gewünschte Person nicht dabei?",
  PERSON_NOT_FOUND_TEXT:
    "Sie können eine zeichnungsberechtigte Person hinzufügen, jedoch müssen Sie für diese Person eine Vollmacht hochladen.",
  PDF_DOCUMENT: "PDF Dokument",
  UPLOAD_POA_BUTTON: "POA-Dokument hochladen",
  UPLOAD_POA_UPLOADED: "POA-Dokument hochgeladen",
  // UPLOAD_POA_HINT: "PDF, PNG or JPG bis zu 10 MB",
  DELETE_LABEL: "Löschen",
  FIRST_NAME_LABEL: "Vorname",
  LAST_NAME_LABEL: "Nachname",
  BIRTH_DATE_LABEL: "Geburtsdatum",
  SIGNING_STEP_LABELS: [
    "Stufe 1:\nE-Mail an Halter",
    "Stufe 2:\nIdentifizierung",
    "Stufe 3:\nSignatur",
    "Stufe 4:\nAbgeschlossen",
  ],
  SIGNING_PENDING_MESSAGE:
    "Das signierte Dokument wird hier nach Abschluss der Signatur angezeigt.",
  IDM_SIGNING_STEP_LABELS: [
    "Erstellt",
    "Verifizierung\nausstehend",
    "Unterzeichner-\nauswahl",
    "In Bearbeitung",
    "Empfangen",
  ],
  SIGNED_BADGE: "Signiert",
  // Error state
  SIGNING_ERROR_TITLE: "Fehlermeldung",
  SIGNING_ERROR_GENERIC:
    "Bei der Signierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  BACK_TO_PROVIDER_BUTTON: "Zurück zur Anbieterauswahl",
  RESTART_SIGNING_BUTTON: "Signatur starten",
  SIGNING_ERROR_PLACEHOLDER:
    "Falls ein Fehler in einer Stufe auftritt, wird der Grund hier angezeigt.",

  // Non-representative POA document requirement
  UPLOAD_POA_REQUIRED: "Bitte laden Sie die Vollmacht hoch",
  VALIDATION_ERROR: "Bitte füllen Sie alle erforderlichen Felder aus.",
};
